<template>
  <div class="xiangmu-list">
    <!-- <div >111</div> -->
    <div
      v-for="(item, index) in xiangmuList"
      :key="index"
      class="xiangmu"
      @click="toxiangmu2(item)"
    >
      <div>
        <el-carousel
          height="220px"
          indicator-position="none"
          v-if="item.imgList && item.imgList.length > 0"
        >
          <el-carousel-item v-for="(item1, index) in item.imgList" :key="index">
            <el-image
              :src="item1"
              style="height: 220px; width: 100%"
            ></el-image>
          </el-carousel-item>
        </el-carousel>
        <img
          style="
            width: 100%;
            height: 220px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
          "
          v-else
          src="../../assets/img/zanwu.png"
        />
        <div
          class="xiang-status"
          :style="{
            'background-color':
              Number(item.status) > 6 &&
              (item.status == 10 || item.status == 11)
                ? '#666'
                : '#f00',
          }"
        >
          {{
            Number(item.status) > 6
              ? item.status == 10 || item.status == 11
                ? "已结束"
                : "已成交"
              : statusList[item.status]
          }}
        </div>
        <div class="main-content">
          <div class="xiang-title">
            {{
              (item.deptName ? item.deptName : item.areaName) +
              (item.projectName ? item.projectName : item.projectname)
            }}
          </div>
          <!-- <div class="xiang-content">采购方：<span> {{ item.tendername }}</span></div> -->
          <div class="xiang-content">
            <img src="../../assets/img/卡片图标1.png" />{{
              item.status
                ? item.status < 7 || (item.status >= 7 && item.signCts == 0)
                  ? cityDetail.initPriceTitle || "挂牌价格"
                  : cityDetail.bargainPriceTitle || "成交金额"
                : ""
            }}：<span class="price-year">
              {{ item.dealAmount || item.price || item.amount }}
              元/年/{{
                getDictsVal(
                  dicts.unitList,
                  item.areaUnit ? item.areaUnit : item.unit
                )
              }}</span
            >
          </div>
          <!-- <div class="xiang-content">预算金额：<span class="price-year"> {{ item.price }}</span>元</div> -->
          <div
            class="xiang-content"
            v-if="item.releaseRecord && item.releaseRecord.projectType != 1"
          >
            <img src="../../assets/img/卡片图标2.png" />交易数量：<span>
              {{ item.area }}
              {{
                getDictsVal(
                  dicts.unitList,
                  item.areaUnit ? item.areaUnit : item.unit
                )
              }}</span
            >
          </div>
          <div class="xiang-content" v-else>
            <img src="../../assets/img/卡片图标2.png" />项目规模：<span>
              {{ item.scale }}</span
            >
          </div>
          <!-- <div class="xiang-content">采购代理机构：<span> {{ item.agentname }}</span></div> -->
          <div class="xiang-content">
            <img src="../../assets/img/卡片图标4.png" />
            <span class="xiang-content-option"
              >{{
                item.releaseRecord && item.releaseRecord.projectType == 2
                  ? "转出方"
                  : item.releaseRecord && item.releaseRecord.projectType == 3
                  ? "需求方"
                  : "招标方"
              }}：</span
            ><span
              class="xiang-content-name"
              :title="
                item.outname
                  ? item.outname
                  : item.needname
                  ? item.needname
                  : item.company
              "
            >
              {{
                item.outname
                  ? item.outname
                  : item.needname
                  ? item.needname
                  : item.company
              }}</span
            >
          </div>
          <!-- <div class="xiang-content">招标文件领取结束时间:<span> {{ item.getstoptime }}</span></div> -->
          <div class="xiang-content">
            <img src="../../assets/img/卡片图标3.png" />
            <!-- 报名截止时间：<span>
              {{ item.releaseRecord && item.releaseRecord.applyStopTime }}</span
            > -->

            <div
              class="time"
              v-if="item.releaseRecord && item.releaseRecord.projectType != 1"
            >
              <span v-if="item.status <= 2">
                公示截止时间：{{
                  item.releaseRecord && item.releaseRecord.publicityStopTime
                }}
              </span>
              <span v-if="item.status == 3 || item.status == 4">
                报名截止时间：{{
                  item.releaseRecord && item.releaseRecord.applyStopTime
                }}
              </span>
              <span v-if="item.status == 5">
                竞价开始时间：{{
                  item.releaseRecord && item.releaseRecord.biddingStartTime
                }}
              </span>
              <span v-if="item.status >= 6">
                竞价截止时间：{{
                  item.releaseRecord && item.releaseRecord.biddingStopTime
                }}
              </span>
            </div>
            <div
              class="time"
              v-if="item.releaseRecord && item.releaseRecord.projectType == 1"
            >
              <span v-if="item.status <= 4">
                报名开始时间：{{
                  item.releaseRecord && item.releaseRecord.applyStartTime
                }}
              </span>
              <span v-else>
                报名截止时间：{{
                  item.releaseRecord && item.releaseRecord.applyStopTime
                }}
              </span>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            font-size: 20px;
            padding: 10px 0;
            box-sizing: border-box;
            border-top: 1px solid #ddd;
            color: #999;
          "
        >
          <div
            style="border-right: 1px solid #ddd; flex: 1; text-align: center"
          >
            <span>浏览次数：{{ item.watchCts ? item.watchCts : "0" }} 次</span>
          </div>
          <div
            style="flex: 1; text-align: center"
            v-if="!cityDetail.notShowWatchNum"
          >
            <span>报名人数：{{ item.signCts ? item.signCts : "0" }} 人</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getTypeList,
} from "@/api/交易项目详情"
import { cityDetail } from "../../util/mainOption"
export default {
  name: "XiangMu",
  data () {
    return {
      statusList: (cityDetail.projectCardShowStatusList || [
        "",
        "",
        "公示中",
        "公示结束",
        "报名中",
        "报名结束",
        "竞价中",
        "已成交",
        "已成交",
        "已成交",
        "已结束",
        "已结束",
      ]),
      // 字典列表
      dicts: {
        // 单位列表
        unitList: [],
      },
    }
  },
  created () {
    // this.xiangmuList.forEach(item => {
    //     if (item.imgs_arr.length > 0) {
    //         item.imgSrc = item.imgs_arr.map(item => this.requestUrl + item)
    //     } else if (item.addressimg) {
    //         item.imgSrc = [this.requestUrl1 + item.addressimg]
    //     } else {
    //         item.imgSrc = []
    //     }
    // })
    console.log(this.xiangmuList, "项目详情")
    getTypeList("area_unit").then((res) => {
      this.dicts.unitList = res.data.data
    })
  },
  props: ["xiangmuList", "type"],
  methods: {
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ""
      }
      return ""
    },
    // 跳转到交易项目详情
    toxiangmu2 (data) {
      // console.log(data);
      // if (data.number && data.number == '009') {
      //     this.$router.push({ path: '/tradingProject/pressCenterDetail1', query: { id: data.id, keys: data.keys, number: this.number } });
      // } else {
      //     if (this.type == 1) {
      //     this.$router.push({ name: '招投标详情', query: { id: data.id, type: this.type } });
      // } else
      console.log("this.type", this.type)
      if (this.type == 1) {
        this.$router.push({
          name: "招投标详情",
          query: { id: data.id, },
        })
      } else if (this.type == 2) {
        this.$router.push({
          name: "交易项目详情",
          query: { id: data.id, },
        })
      } else if (this.type == 3) {
        this.$router.push({
          name: "产权需求详情",
          query: { id: data.id, },
        })
      }
      // }
    },
  },
}
</script>

<style scoped>
.imgnull {
  height: 220px;
  width: 100%;
  line-height: 220px;
  text-align: center;
  color: #c0c4cc;
  /* font-size: 28px; */
  box-sizing: border-box;
  background-color: #f5f7fa;
  /* border-bottom:1px solid #666 ; */
}

.price-year {
  color: red;
  font-size: 20px;
  font-weight: 500;
}

.xiangmu-list {
  /* position: relative; */
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr !important;
  grid-gap: 30px;
  font-size: 16px;
  padding: 10px;
}

.main-content {
  padding: 10px 20px 10px 20px;
}

.greenClass {
  background-color: #00a213;
}

.redClass {
  background-color: #ff0000;
}

.orangeClass {
  background-color: orange;
}

.xiang-status {
  width: 120px;
  height: 40px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 10px 0 0 10px;
  float: right;
  background-color: #ff0000;
  position: absolute;
  right: 0;

  top: 160px;
  z-index: 99;
  /* position: relative;


    right: 0;
    top: 30px; */
}

.xiang-title {
  /* border: 1px solid red; */
  /* text-align: center;  */
  width: 390px;
  /* width: 100%; */
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 10px;
  color: #262626;
  height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.xiangmu {
  height: 480px;
  position: relative;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  box-sizing: border-box;
  transition-timing-function: ease-out;
  transition-duration: 300ms;
  /* transition-delay: 3s; */
}

.xiangmu:hover {
  border: 3px solid red;
  transform: translate(0, -5px);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
}

.xiang-content {
  /* border: 1px solid red; */
  font-size: 20px;
  height: 37px;
  line-height: 37px;
  color: #616161;
  align-items: center;
  display: flex;
}

.xiang-content > img {
  width: 20px;
  margin-right: 10px;
}

.xiang-content > .xiang-content-option {
  white-space: nowrap;
}
.xiang-content > .xiang-content-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 300px;
}
</style>
